export function sidebarLinks() {
  $(window).on("load", () => {
    const links = $(".sidebar-links");
    const expandBtn = links.find(".expand-btn");
    expandBtn.on("click", function () {
      const $this = $(this);
      $this.parent().toggleClass("expanded");
      $this.siblings(".sub-menu").slideToggle("fast");
      if($this.parent().hasClass("current_page_item") || $this.parent().hasClass("current_page_parent")) {
        $this.parent().removeClass("expanded current_page_item current_page_parent");
        $this.siblings(".sub-menu").slideUp("fast");
      }
    });
    links.find("li").each(function () {
      const $this = $(this);
      if (
        $this.hasClass("expanded") || 
        $this.hasClass("current-menu-item") || 
        $this.hasClass("current_page_item") || 
        $this.hasClass("current_page_parent")
      ) {
        $this.parents(".menu-item-has-children").addClass("expanded");
        $this.find(".sub-menu").css("display", "block");
      }
    });
  });
}


// WEBPACK FOOTER //
// ./assets/js/modules/sidebarLinks.js